
    <div class="fs-16">
      <p class="mb-3 grey-text">Add more Favourite Videos from the Video Library.</p>
      <div class="row mb-2 custom-inputs">
        <div class="col-sm-4">
          <input type="text" id="dashboard-search-input1" [(ngModel)]="keyword"
          (ngModelChange)="updateOnlyOnBlur($event)" placeholder="Filter by Title" class="form-control">
        </div>
        <div class="col-12" *ngIf="type!='fav'">
          
          <div class="scrolldiv2">
            <div class="row py-3">
              <div class="col-sm-3 mb-3" *ngFor="let video of videosList">
                <app-fav-video-item *ngIf="type=='fav'" (newItemEvent)="addItem($event)" [modalid]="modalid" [videosList]="videosList" [video]="video"></app-fav-video-item>
                <app-fav-video-item-add-video (addRemoveToPlaylist)="addRemoveToPlaylist($event)" [selectedPlaylist]="selectedPlaylist" *ngIf="type=='video'" (newItemEvent)="addItem($event)" [modalid]="modalid" [videosList]="videosList" [video]="video"></app-fav-video-item-add-video>
              </div>
            </div>
            <div class="text-center" *ngIf="totalvideo > videosListAll.length">
              <button class="btn btn-sm btn-gold me-4" (click)="showMore()">Load More</button>
            </div>
          </div>
        </div>
        
        <div class="col-12" *ngIf="type=='fav'">
          <div class="scrolldiv2">
            <div class="row py-3">
              <div class="col-sm-3 mb-3" *ngFor="let video of items">
                <app-fav-video-item (newItemEvent)="addItem($event)" [modalid]="modalid" [videosList]="videosList" [video]="video"></app-fav-video-item>
              </div>
            </div>
            <div class="text-center" *ngIf="currentIndex < videosList.length && this.keyword.length==0">
              <button class="btn btn-sm btn-gold me-4" (click)="LoadMoreLocal()">Load More</button>
            </div>
            <div class="text-center" *ngIf="currentIndex < filterVideos.length && this.keyword.length>0">
              <button class="btn btn-sm btn-gold me-4" (click)="LoadMoreLocal()">Load More</button>
            </div>
          </div>
        </div>
          <!-- <div _ngcontent-ivh-c54="" class="invalid-feedback d-block"> Please fill valid email. </div> -->
      </div>
      
      <ng-container *ngIf="webApi.isLoggedIn() && videosList && videosList.length>0">
        <app-video-details [modalid]="modalid" [videoDetails]="videoDetails"></app-video-details>
      </ng-container>
    </div>